import Vue from "vue";
import ShoppingCartItem from "./ShoppingCartItem";

class ShoppingCartContainer extends EventTarget {
  /**
   *
   * @param {array<ShoppingCartItem>} items
   */
  constructor(items = []) {
    super();

    items = items.map(
      ({ id, img, title, price, observations, quant, variant }) =>
        new ShoppingCartItem(
          id,
          img,
          title,
          price,
          observations,
          quant,
          variant
        )
    );

    this.state = Vue.observable({ items });
  }

  get items() {
    return this.state.items;
  }

  add({ id, img, title, price, observations, quant = 1, variant }) {
    let item = this.state.items.find(
      (item) =>
        id == item.id &&
        observations == item.observations &&
        ((item.variant !== null && variant.id == item.variant.id) ||
          (!item.variant && !item.variant))
    );

    if (item) {
      for (let i = 0; quant > i; i++) item.increment();
    } else {
      let item = new ShoppingCartItem(
        id,
        img,
        title,
        price,
        observations,
        quant,
        variant
      );
      this.state.items.push(item);
    }

    this.dispatchEvent(new CustomEvent("add", { detail: item }));

    return this.state.items;
  }

  remove(item) {
    const index = this.state.items.indexOf(item);

    if (index === -1) return;

    this.state.items.splice(index, 1);
  }

  clear() {
    this.state.items = [];
  }
}

export default ShoppingCartContainer;
